import { render, staticRenderFns } from "./ChooseCountrySvg.vue?vue&type=template&id=12cf9ea0&"
import script from "./ChooseCountrySvg.vue?vue&type=script&lang=ts&"
export * from "./ChooseCountrySvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports